import { User } from './user.model';
import { Company } from './company.model';

export class AccountDetailRequest {
  userId?: number;
  primaryUser: User;
  company: Company;
  secondaryUser: User;
}

export class UpdateAccountDetailsRequest {
  primaryUser: User;
  companyDetails: Company;
  secondaryUser: User;
}

export class AccountDetails {
  primaryUser: User;
  companyDetails: Company;
  secondaryUser: User;
}
